/**
 * Square AI logo — a modern flat-design SVG.
 * - Rounded square with cyan-blue gradient
 * - White chat bubble in the centre
 * - Small circuit nodes on the corners
 * - Scalable, no external assets, no copyright material
 */
const SquareAILogo = ({ size = 40, className = "", ariaLabel = "Square Bot" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    role="img"
    aria-label={ariaLabel}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="sq-ai-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#4dd7ee" />
        <stop offset="60%" stopColor="#2f9fe0" />
        <stop offset="100%" stopColor="#1e6cd8" />
      </linearGradient>
      <linearGradient id="sq-ai-glow" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.24" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </linearGradient>
    </defs>

    {/* Rounded gradient tile */}
    <rect x="2" y="2" width="44" height="44" rx="12" fill="url(#sq-ai-grad)" />
    {/* Subtle top gloss */}
    <rect x="2" y="2" width="44" height="20" rx="12" fill="url(#sq-ai-glow)" />

    {/* Circuit nodes + connector lines */}
    <g stroke="#ffffff" strokeOpacity="0.55" strokeWidth="1" strokeLinecap="round">
      <line x1="10" y1="10" x2="14" y2="14" />
      <line x1="38" y1="10" x2="34" y2="14" />
      <line x1="10" y1="38" x2="14" y2="34" />
      <line x1="38" y1="38" x2="34" y2="34" />
    </g>
    <g fill="#ffffff">
      <circle cx="10" cy="10" r="1.6" />
      <circle cx="38" cy="10" r="1.6" />
      <circle cx="10" cy="38" r="1.6" />
      <circle cx="38" cy="38" r="1.6" />
    </g>

    {/* Chat bubble */}
    <path
      d="M14 18h20a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H24l-5 4v-4h-5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3z"
      fill="#ffffff"
    />
    {/* Bubble dots */}
    <g fill="#2f9fe0">
      <circle cx="19" cy="25" r="1.6" />
      <circle cx="24" cy="25" r="1.6" />
      <circle cx="29" cy="25" r="1.6" />
    </g>
  </svg>
);

export default SquareAILogo;
